import type { ToolbarItem } from '@disco/shared-components/rich-text-editor'

/**
 * Must include every formatting item the create/edit editor allows, since
 * discussion-body.tsx renders notes read-only with this same list — if a
 * note's stored content contains a mark this list omits, the read-only
 * schema won't recognize it and will silently strip it (SLAM-1988).
 */
export const TRACK_NOTE_TOOLBAR_ITEMS: ToolbarItem[] = [
  'timestamp',
  'bold',
  'italic',
  'underline',
  'bullet-list',
  'ordered-list',
  'link',
  'submit',
]
